import React, { useState,useEffect } from "react";
import "./DataEngineeringLevelTabs.css";
import DataEngineeringFoundTrack from "./DataEngineeringFoundTrack";
import DataEngineeringIntermediateTrack from "./DataEngineeringIntermediateTrack";
import DataEngineeringAdvancedTrack from "./DataEngineeringAdvancedTrack";
import WebDeveloperFoundTrack from "./WebDeveloperFoundTrack";
import WebDeveloperIntermediateTrack from "./WebDeveloperIntermediateTrack";
import WebDeveloperAdvancedTrack from "./WebDeveloperAdvancedTrack";
import { WebImagesParams} from "../../imagesData/ImagesData";
import axios from "axios";
import baseUrl from "../../utils/Constants.js";

function WebDeveloperLevelTabs() {
  const [tabCol, setTabCol] = React.useState("beg");

  var divStyle = {
    backgroundImage:
      "url(" +
      process.env.PUBLIC_URL +
      "/images/DataEngineering/data-active-bg.png)",
  };

  var divDisabledStyle = {
    backgroundImage:
      "url(" +
      process.env.PUBLIC_URL +
      "/images/DataEngineering/data-disable-bg.png)",
  };

  const setStyle = (col) => {
    setTabCol(col);
  };

  const [imageUrls, setImageUrls] = useState({});
  const query = `params=${encodeURIComponent(JSON.stringify(WebImagesParams))}`;

  useEffect(() => {
    const fetchImageUrls = async () => {
      try {
        const response = await axios.get(`${baseUrl}/images?${query}`)
        setImageUrls(response.data); 
      } catch (error) {
        console.error('Error fetching image URLs:', error);
      }
    };
  
    fetchImageUrls();
  }, []);

  return (
    <>
      <ul class="nav nav-tabs" id="myTab" role="tablist">
        <li
          class="nav-item"
          role="presentation"
          onClick={() => setStyle("beg")}
        >
          <button
            class="nav-link active"
            id="home-tab"
            data-bs-toggle="tab"
            data-bs-target="#home"
            type="button"
            role="tab"
            aria-controls="home"
            aria-selected="true"
            style={tabCol == "beg" ? divStyle : divDisabledStyle}
          >
            <h3>
              <span className="course-level">Junior</span>
              <span>P1</span>
            </h3>
          </button>
        </li>
        <li
          class="nav-item"
          role="presentation"
          onClick={() => setStyle("inter")}
        >
          <button
            class="nav-link"
            id="profile-tab"
            data-bs-toggle="tab"
            data-bs-target="#profile"
            type="button"
            role="tab"
            aria-controls="profile"
            aria-selected="false"
            style={tabCol == "inter" ? divStyle : divDisabledStyle}
          >
            <h3>
              <span className="course-level">Mid</span>
              <span>P2</span>
            </h3>
          </button>
        </li>
        <li
          class="nav-item"
          role="presentation"
          onClick={() => setStyle("advanced")}
        >
          <button
            class="nav-link"
            id="contact-tab"
            data-bs-toggle="tab"
            data-bs-target="#contact"
            type="button"
            role="tab"
            aria-controls="contact"
            aria-selected="false"
            style={tabCol == "advanced" ? divStyle : divDisabledStyle}
          >
            <h3>
              <span className="course-level">Senior</span>
              <span>P3</span>
            </h3>
          </button>
        </li>
      </ul>
      <div class="tab-content" id="myTabContent">
        <div
          class="tab-pane fade show active"
          id="home"
          role="tabpanel"
          aria-labelledby="home-tab"
        >
          <h3>Web Developer Learning Journey</h3>
          <img
            src={
              process.env.PUBLIC_URL +
              "/images/DataEngineering/hours-foundation-border-img.png"
            }
            //src="images/DataEngineering/hours-foundation-border-img.png"
            alt="hours"
            className="hours-border-img"
          />
          <p>
            Build your web development foundation, mastering the essentials of
            pipelines and infrastructure to shape a robust learning journey.
          </p>
          <img
            src={imageUrls?.imageUrl?.img2}
            alt="foundation"
            className="data-foundation-info"
          />
          <img
            src={
              process.env.PUBLIC_URL +
              "/images/DataEngineering/info-border-img.png"
            }
            //src="images/DataEngineering/info-border-img.png"
            alt="foundation"
            className="info-border-img"
          />
          <div className="foundation-track-sec">
            <div className="foundation-track-wrap">
              <h2>Web Developer Junior Track</h2>
              <p>
                Forge a solid foundation in web development, exploring
                fundamental principles and hands-on skills to propel your
                learning track toward the heart of data-driven excellence.
              </p>
              <WebDeveloperFoundTrack />
            </div>
          </div>
        </div>
        <div
          class="tab-pane fade"
          id="profile"
          role="tabpanel"
          aria-labelledby="profile-tab"
        >
          <h3>Web Developer Learning Journey</h3>
          <img
            src={
              process.env.PUBLIC_URL +
              "/images/DataEngineering/hours-intermediate-border-img.png"
            }
            //src="images/DataEngineering/hours-intermediate-border-img.png"
            alt="hours"
            className="hours-border-img"
          />
          <p>
            Navigate the intermediate terrain of web development, where you
            deepen your understanding of pipelines, optimization, and contribute
            to the evolution of resilient data systems.
          </p>
          <img
            src={imageUrls?.imageUrl?.img3}
            alt="foundation"
            className="data-foundation-info"
          />
          <img
            src={
              process.env.PUBLIC_URL +
              "/images/DataEngineering/info-border-img.png"
            }
            //src="images/DataEngineering/info-border-img.png"
            alt="foundation"
            className="info-border-img"
          />
          <div className="foundation-track-sec">
            <div className="foundation-track-wrap inter-track-wrap">
              <h2>Web Developer Mid Track</h2>
              <p>
                Elevate your web developer expertise in the intermediate track,
                where complexity meets mastery, and you refine your ability to
                design, implement, and optimize advanced data systems.
              </p>
              <WebDeveloperIntermediateTrack />
            </div>
          </div>
        </div>
        <div
          class="tab-pane fade"
          id="contact"
          role="tabpanel"
          aria-labelledby="contact-tab"
        >
          <h3>Web Developer Learning Journey</h3>
          <img
            src={
              process.env.PUBLIC_URL +
              "/images/DataEngineering/hours-advanced-border-img.png"
            }
            //src="images/DataEngineering/hours-advanced-border-img.png"
            alt="hours"
            className="hours-border-img"
          />
          <p>
            In the advanced phase of your web developer journey, ascend to
            mastery, conquering complex challenges, architecting scalable
            solutions, and shaping the future of data-driven innovation.
          </p>
          <img
            src={imageUrls?.imageUrl?.img1}
            alt="foundation"
            className="data-foundation-info"
          />
          <img
            src={
              process.env.PUBLIC_URL +
              "/images/DataEngineering/info-border-img.png"
            }
            //src="images/DataEngineering/info-border-img.png"
            alt="foundation"
            className="info-border-img"
          />
          <div className="foundation-track-sec">
            <div className="foundation-track-wrap advanced-track-wrap">
              <h2>Web Developer Senior Track</h2>
              <p>
                In the advanced phase of your web developer learning track,
                conquer complexity, refine optimization strategies, and lead the
                forefront of data engineering innovation, shaping the landscape
                of future technologies.
              </p>
              <WebDeveloperAdvancedTrack />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default WebDeveloperLevelTabs;
